var _defs, _g, _path, _path2, _g2, _path3, _g3, _g4, _path4, _g5, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "f75bc40917"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "278ebbdd84"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#f75bc40917)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#000000",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 0.79
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "e47c22deaf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.421875 0.761719 L 278.582031 0.761719 L 278.582031 347 L 3.421875 347 Z M 3.421875 0.761719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "08030f4921"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.421875 0.761719 L 85 0.761719 L 85 81 L 3.421875 81 Z M 3.421875 0.761719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c962b2877f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.421875 79 L 86 79 L 86 188 L 3.421875 188 Z M 3.421875 79 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "5d436b4948"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#f75bc40917)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -123.5,
    width: 540,
    fill: "#000000",
    y: -87.499998,
    height: 539.999987,
    fillOpacity: 0.72
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "2c5d2fbee8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.640625 1 L 81 1 L 81 107 L 0.640625 107 Z M 0.640625 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "68fd9cfdd4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 83,
    y: 0,
    height: 109
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4d8c26d113"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 280,
    y: 0,
    height: 349
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e5057fe977"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 96.546875 131.082031 L 269 131.082031 L 269 303 L 96.546875 303 Z M 96.546875 131.082031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "40cfd1e32e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 261 296 L 336 296 L 336 370.4375 L 261 370.4375 Z M 261 296 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3345a946b8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 108.449219 143.5625 L 255.570312 143.5625 L 255.570312 290.683594 L 108.449219 290.683594 Z M 108.449219 143.5625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1c2c7f3070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 182.007812 143.5625 C 141.382812 143.5625 108.449219 176.496094 108.449219 217.121094 C 108.449219 257.75 141.382812 290.683594 182.007812 290.683594 C 222.636719 290.683594 255.570312 257.75 255.570312 217.121094 C 255.570312 176.496094 222.636719 143.5625 182.007812 143.5625 Z M 182.007812 143.5625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "81c828a018"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#f75bc40917)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#000000",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 0.63
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "88b5394fae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 33 33 L 113 33 L 113 112 L 33 112 Z M 33 33 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "55e38ff357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.792969 72.777344 L 72.996094 0.574219 L 145.199219 72.777344 L 72.996094 144.980469 Z M 0.792969 72.777344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4573a25878"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.792969 72.777344 L 72.996094 0.574219 L 145.199219 72.777344 L 72.996094 144.980469 Z M 0.792969 72.777344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "03a2ad6c6c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 146,
    y: 0,
    height: 146
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#278ebbdd84)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 41, 5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4d8c26d113)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e47c22deaf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#acdceb",
    d: "M 30.53125 346.785156 L 251.476562 346.785156 C 266.554688 346.785156 279.011719 334.328125 279.011719 319.25 L 279.011719 28.480469 C 279.011719 13.402344 266.554688 0.945312 251.476562 0.945312 L 84.292969 0.945312 L 2.996094 80.929688 L 2.996094 319.25 C 2.996094 334.328125 15.453125 346.785156 30.53125 346.785156 Z M 30.53125 346.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#08030f4921)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c4f1ff",
    d: "M 84.292969 0.945312 L 84.292969 80.929688 L 2.996094 80.929688 Z M 84.292969 0.945312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#acdceb",
    d: "M 238.363281 111.417969 L 238.363281 259.589844 L 43.644531 259.589844 L 43.644531 111.417969 Z M 55.117188 153.378906 L 174.441406 153.378906 L 174.441406 122.890625 L 55.445312 122.890625 L 55.445312 153.378906 Z M 174.441406 165.179688 L 55.445312 165.179688 L 55.445312 201.566406 L 174.441406 201.566406 Z M 185.914062 201.566406 L 226.5625 201.566406 L 226.5625 165.179688 L 185.914062 165.179688 Z M 185.914062 122.890625 L 185.914062 153.378906 L 226.5625 153.378906 L 226.5625 122.890625 Z M 226.5625 213.039062 L 185.914062 213.039062 L 185.914062 247.785156 L 226.5625 247.785156 Z M 174.441406 248.113281 L 174.441406 213.039062 L 55.445312 213.039062 L 55.445312 247.785156 L 174.441406 247.785156 Z M 174.441406 248.113281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c962b2877f)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#5d436b4948)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3, 79)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#68fd9cfdd4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2c5d2fbee8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#80c5db",
    d: "M 0.648438 1.929688 L 80.636719 1.929688 L 0.648438 106.503906 Z M 0.648438 1.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.097961, 0.00000000000000033, -0.00000000000000033, 1.097961, 145.786298, 30.422946)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 3.001684 3.001749 L 138.793126 3.001749 ",
    stroke: "#259ac1",
    strokeWidth: 6,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.097961, 0, 0, 1.097961, 145.786298, 76.053672)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 3.001684 3.000092 L 113.14545 3.000092 ",
    stroke: "#259ac1",
    strokeWidth: 6,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e5057fe977)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#259ac1",
    d: "M 182.707031 131.097656 C 135.316406 131.097656 96.761719 169.652344 96.761719 217.042969 C 96.761719 264.433594 135.316406 302.984375 182.707031 302.984375 C 230.097656 302.984375 268.648438 264.433594 268.648438 217.042969 C 268.648438 169.652344 230.097656 131.097656 182.707031 131.097656 Z M 182.707031 289.480469 C 142.765625 289.480469 110.269531 256.984375 110.269531 217.042969 C 110.269531 177.101562 142.765625 144.605469 182.707031 144.605469 C 222.648438 144.605469 255.144531 177.101562 255.144531 217.042969 C 255.144531 256.984375 222.648438 289.480469 182.707031 289.480469 Z M 182.707031 289.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#259ac1",
    d: "M 268.808594 291.101562 L 253.636719 275.929688 C 249.871094 280.460938 245.675781 284.628906 241.121094 288.367188 L 256.527344 303.773438 C 257.503906 300.972656 259.109375 298.34375 261.34375 296.109375 L 261.773438 295.679688 C 263.804688 293.648438 266.199219 292.105469 268.808594 291.101562 Z M 268.808594 291.101562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#40cfd1e32e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#259ac1",
    d: "M 286.109375 300.128906 C 283.46875 297.484375 279.9375 296.03125 276.164062 296.03125 C 272.394531 296.03125 268.863281 297.484375 266.222656 300.128906 L 265.792969 300.558594 C 263.148438 303.199219 261.695312 306.730469 261.695312 310.5 C 261.695312 314.269531 263.148438 317.804688 265.792969 320.445312 L 311.5 366.15625 C 314.144531 368.796875 317.675781 370.253906 321.445312 370.253906 C 325.214844 370.253906 328.746094 368.796875 331.390625 366.15625 L 331.820312 365.726562 C 337.304688 360.242188 337.304688 351.320312 331.820312 345.835938 Z M 286.109375 300.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3345a946b8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1c2c7f3070)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c4f1ff",
    d: "M 108.449219 143.5625 L 255.570312 143.5625 L 255.570312 290.683594 L 108.449219 290.683594 Z M 108.449219 143.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.097961, 0, 0, 1.097961, 145.786298, 98.796762)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 3.001684 2.99927 L 76.596889 2.99927 ",
    stroke: "#259ac1",
    strokeWidth: 6,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#81c828a018)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 109, 143)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#03a2ad6c6c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#88b5394fae)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#55e38ff357)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4573a25878)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ee2c7f",
    d: "M 94.667969 36.671875 L 72.976562 58.363281 L 51.316406 36.703125 C 47.328125 32.71875 40.859375 32.714844 36.871094 36.703125 C 32.886719 40.6875 32.886719 47.160156 36.871094 51.144531 L 58.535156 72.808594 L 36.902344 94.441406 C 32.914062 98.425781 32.914062 104.894531 36.902344 108.882812 C 40.886719 112.867188 47.359375 112.867188 51.34375 108.882812 L 72.976562 87.246094 L 94.640625 108.910156 C 98.628906 112.898438 105.097656 112.898438 109.085938 108.910156 C 113.070312 104.925781 113.070312 98.453125 109.082031 94.46875 L 87.421875 72.804688 L 109.109375 51.113281 C 113.097656 47.128906 113.097656 40.65625 109.109375 36.671875 C 105.125 32.6875 98.65625 32.6875 94.667969 36.671875 Z M 94.667969 36.671875 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })))))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.097961, 0, 0, 1.097961, 145.786298, 52.661987)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 3.001684 3.001057 L 92.887735 3.001057 ",
    stroke: "#259ac1",
    strokeWidth: 6,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataColour);
export default __webpack_public_path__ + "static/media/no-data-colour.3290f8222ed8a57db89f720d4088e77f.svg";
export { ForwardRef as ReactComponent };